module.exports = __webpack_public_path__ + "img/selected1-min.e7b18a3c.png";